import gql from "graphql-tag";

const ROSTER_STATUS_QUERY = gql`  
query RosterStatus($chapterId: String!){
    rosterStatus(chapterId: $chapterId) {
      message
      showPrompt
  }
}
`;
export default ROSTER_STATUS_QUERY;